exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".car-data-col[data-v-226cca37]{width:33.33%}", ""]);

// exports
